export default __webpack_public_path__ + "static/media/Logo.11952d1a.png";